import styled from 'styled-components'

export const IconContainer = styled.div.attrs(props => ({
  className: props.e2eClass
}))`
  z-index: 10;
  cursor: pointer;
`

export const NavBarContainer = styled.div`
  position: absolute;
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  padding-bottom: 0;
`
